module.exports = __webpack_public_path__ + "img/license_image7.47eee0a8.png";